import { helpers } from 'vuelidate/lib/validators';
var betweenLength = function (min, max) {
    return helpers.withParams({ type: 'betweenLength' }, function (value) { return value.length >= min && value.length <= max; });
};
export default betweenLength;
